import React, { Component } from "react";
import LinkHelper from "./Link";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types"

export default class FormNavigator extends Component {

    render() {
        return (
            <div className="Content-options">
                <LinkHelper to={this.props.back}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        size={this.props.compact ? "medium" : "large"}
                    >
                        Back
                    </Button>
                </LinkHelper>
                { this.props.isLast ? (
                    <Button
                        variant="contained"
                        color="primary"
                        size={this.props.compact ? "medium" : "large"}
                        disabled={this.props.disabled}
                        onClick={ () => this.props.onSubmit() }
                    >
                        Submit
                    </Button>
                ) : (
                    <LinkHelper 
                        to={this.props.continue}
                        disabled={this.props.disabled}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={this.props.disabled}
                            size={this.props.compact ? "medium" : "large"}
                        >
                            Continue
                        </Button>
                    </LinkHelper>
                ) }
            </div>
        );
    }

}

FormNavigator.propTypes = {
    back: PropTypes.string.isRequired,
    continue: PropTypes.string.isRequired,
    isLast: PropTypes.bool,
    disabled: PropTypes.bool,
    onSubmit: PropTypes.func
}